import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchSystemErrorData = createAsyncThunk('fetchSystemErrorData', async () => {
    try {
        const response = await apiget('api/errors/');
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const systemErrorSlice = createSlice({
    name: 'systemErrorDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: ""
    },
    reducers: {
        // Define reducers here if needed
    },
    extraReducers: (builder) => {
        // Define extra reducers for async thunks if needed
        builder
            .addCase(fetchSystemErrorData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSystemErrorData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchSystemErrorData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    }
});

export default systemErrorSlice.reducer;